import React from 'react';

function SystemCard({ system, onClick }) {
  return (
    <div 
      className="C" 
      onClick={() => onClick(system)}
      style={{ cursor: 'pointer' }}
    >
      {/* Gradient top bar */}
      <div style={{ 
        height: '3px', 
        background: system.color.includes(',') 
          ? system.color 
          : `linear-gradient(90deg, ${system.color}, ${system.color}dd)` 
      }} />
      
      <div style={{ padding: '12px 14px' }}>
        {/* Header section */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start', 
          marginBottom: '6px' 
        }}>
          <div>
            <div style={{ 
              fontSize: '8px', 
              fontWeight: '700', 
              color: system.color.split(',')[1]?.split(')')[0] || system.color,
              letterSpacing: '1px', 
              textTransform: 'uppercase' 
            }}>
              {system.system_number}
            </div>
            <div style={{ 
              fontSize: '14px', 
              fontWeight: '800', 
              color: '#111827' 
            }}>
              {system.name}
            </div>
            <div style={{ 
              fontSize: '10px', 
              color: '#6B7280' 
            }}>
              {system.subtitle}
            </div>
          </div>
          
          {/* Badge */}
          <div style={{ 
            padding: '2px 6px', 
            borderRadius: '4px', 
            background: `${system.color.split(',')[1]?.split(')')[0] || system.color}10`,
            border: `1px solid ${system.color.split(',')[1]?.split(')')[0] || system.color}20`,
            fontSize: '9px', 
            fontWeight: '700', 
            color: system.color.split(',')[1]?.split(')')[0] || system.color,
            whiteSpace: 'nowrap' 
          }}>
            {system.system_type.replace(' System', '')}
          </div>
        </div>
        
        {/* Description */}
        <p style={{ 
          fontSize: '9px', 
          color: '#4B5563', 
          lineHeight: '1.4', 
          margin: '0 0 8px', 
          fontStyle: 'italic' 
        }}>
          {system.description}
        </p>
        
        {/* Dosage table preview */}
        {system.dosage_tables && Object.keys(system.dosage_tables).length > 0 && (
          <div style={{ 
            background: '#F0F9FF', 
            border: '1px solid #BAE6FD', 
            borderRadius: '6px', 
            padding: '8px', 
            marginBottom: '8px' 
          }}>
            <div style={{ 
              fontSize: '7px', 
              fontWeight: '700', 
              color: '#0369A1', 
              letterSpacing: '0.5px', 
              textTransform: 'uppercase', 
              marginBottom: '4px' 
            }}>
              {Object.keys(system.dosage_tables)[0]} Dosage Guide
            </div>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse', 
              fontSize: '8px' 
            }}>
              <thead>
                <tr style={{ background: '#0288D110' }}>
                  <th style={{ 
                    padding: '3px 4px', 
                    textAlign: 'left', 
                    color: '#0369A1', 
                    fontWeight: '700', 
                    borderBottom: '1px solid #BAE6FD' 
                  }}>
                    Target BN
                  </th>
                  {system.dosage_tables[Object.keys(system.dosage_tables)[0]].components?.map((comp, idx) => (
                    <th key={idx} style={{ 
                      padding: '3px 4px', 
                      textAlign: 'center', 
                      color: '#0369A1', 
                      fontWeight: '700', 
                      borderBottom: '1px solid #BAE6FD' 
                    }}>
                      {comp}
                    </th>
                  ))}
                  <th style={{ 
                    padding: '3px 4px', 
                    textAlign: 'center', 
                    color: '#0369A1', 
                    fontWeight: '700', 
                    borderBottom: '1px solid #BAE6FD' 
                  }}>
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {system.dosage_tables[Object.keys(system.dosage_tables)[0]].rows?.slice(0, 3).map((row, idx) => (
                  <tr key={idx} style={{ background: idx % 2 === 1 ? '#F8FAFC' : 'transparent' }}>
                    <td style={{ 
                      padding: '2px 4px', 
                      color: '#374151', 
                      fontWeight: '700' 
                    }}>
                      {row.target}
                    </td>
                    {row.values?.map((val, vidx) => (
                      <td key={vidx} style={{ 
                        padding: '2px 4px', 
                        textAlign: 'center', 
                        color: '#374151', 
                        fontFamily: 'monospace' 
                      }}>
                        {val}
                      </td>
                    ))}
                    <td style={{ 
                      padding: '2px 4px', 
                      textAlign: 'center', 
                      color: '#0369A1', 
                      fontWeight: '800', 
                      fontFamily: 'monospace' 
                    }}>
                      {row.total}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {system.dosage_tables[Object.keys(system.dosage_tables)[0]].rows?.length > 3 && (
              <div style={{ 
                fontSize: '7px', 
                color: '#6B7280', 
                marginTop: '4px', 
                textAlign: 'center' 
              }}>
                +{system.dosage_tables[Object.keys(system.dosage_tables)[0]].rows.length - 3} more options
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default SystemCard;
